import React, { useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Select, Button, Modal, Alert, message } from 'antd';
import { Grid } from '@material-ui/core';
import TextEvents from '../TextEvents';
import TextInput from 'app/components/TextInput';
import { styles, useStyles } from './CompanyFormStyles';
import CompanyTableContainer from 'app/containers/CompanyTableContainer';
import { fetchCompany, companyClear, companyFilterClear, fetchCompanyFilter } from 'app/actions/CompanyActions';
import ApiService from 'app/services/ApiService';

const { confirm } = Modal;
const { Option } = Select;
const SelectItem = (name = [], value) => {
    let x = name[value]
    return typeof x !== 'undefined' && x !== null ? x.map((c, i) => <Option key={i}>{c}</Option>) : (x === null ? <Option key={'cargando'}>No existen valores..</Option> : <Option disabled key={'cargando'}>Cargando valores..</Option>);

}

export default function CompanyForm(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [name, setName] = useState([]);
    const data = {
        clientName: props.FiltroCompany.join('|'),
        sortColumn: Object.keys(props.sorter).length > 0 ? props.sorter.field : '',
        sortDir: Object.keys(props.sorter).length > 0 ? props.sorter.order === "ascend" ? "ASC" : "DESC" : '',
        offset: (0 * props.pagination.pageSize),
        limit: props.pagination.pageSize
    }

    const { siteId } = useSelector(state => state.Auth);

    const submit = () => {
        ApiService.setClient({ idClient: props.idClient, clientName: props.nameClient }, props.idClient > 0 ? 'PUT' : 'POST').then(
            res => {
                props.isVisibleForm(false)
                message.success(`La Compañía ${props.nameClient} se guardó correctamente!`);
                dispatch(companyFilterClear());
                dispatch(fetchCompanyFilter());
                search();
                props.setNameClient('');

            },
            error => {
                message.error('Ocurrió un error intente mas tarde.');
            }
        );
    }
    const search = () => {
        dispatch(companyClear());
        dispatch(fetchCompany(data));
        props.setFormData(data);
    }

    const newSpecialty = () => {
        props.setIdClient(0);
        props.setNameClient('');
        props.isVisibleForm(true);
    }

    const toExport = async () => {
        await ApiService.getClientExport(data)
            .then(
                result => {
                    const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    downloadFile(blob, "BandejaCompañías.xlsx");
                },
                error => {
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    }

    const downloadFile = (blob, fileName) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.append(link);
        link.click();
        link.remove();
        window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
    };

    const handleChange = (value, i, key) => {
        const array = [];
        i.map(i => {
            array.push(i.props.children);
            return array;
        })
        if (i.length === 0) {
            switch (key) {
                case 'clientName':
                    setName([])
                    props.setFiltroCompany([]);
                    break;
                default:
                    break;
            }
        }
        // eslint-disable-next-line array-callback-return
        i.map(() => {
            if (key === 'clientName') {
                setName([array])
                props.setFiltroCompany(array);
            }
        });
    }

    return (
        <div>
            <CompanyTableContainer>
                {(params) => {
                    return (
                        <div>
                            <Grid container direction="row">
                                <Grid item xs={6}>
                                    <TextEvents
                                        text='Nombre:'
                                        color="darker"
                                        size='label'
                                        weight="medium"
                                    />
                                    <Select
                                        mode="multiple"
                                        showSearch
                                        value={props.FiltroCompany}
                                        optionFilterProp="children"
                                        style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                        placeholder="Selecciona nombre"
                                        onChange={(v, i) => handleChange(v, i, 'clientName')}
                                    >
                                        {SelectItem(params.companyFilter[0], 'name')}
                                    </Select>
                                </Grid>
                            </Grid>
                            <div className={classes.container} style={styles.baseVerticalMargin}>
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    type="primary"
                                    onClick={() => search()}
                                >
                                    Buscar
                                </Button>
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    type="primary"
                                    onClick={toExport}
                                >
                                    Exportar
                                </Button>
                                {
                                    siteId === 'HUB' ?
                                        <Button
                                            className={classes.button}
                                            variant="contained"
                                            type="primary"
                                            onClick={newSpecialty}
                                        >
                                            Nuevo
                                        </Button> : null
                                }
                            </div>
                        </div>
                    )
                }}
            </CompanyTableContainer>
            <Modal
                destroyOnClose={true}
                onCancel={() => props.isVisibleForm(false)}
                visible={props.visibleForm}
                title={<TextEvents
                    text={props.idClient > 0 ? 'Editar Compañía' : 'Nueva Compañía'}
                    color='cotemar'
                    size='label'
                    weight='bold'
                />}
                width={'650px'}
                centered={true}
                footer={[
                    <Button key="back" type="danger" ghost onClick={() => props.isVisibleForm(false)}>
                        Cancelar
                    </Button>,
                    siteId === 'HUB' ?
                        <Button disabled={props.nameClient === ''} key="submit" type="primary" loading={false} onClick={() => submit()}>
                            Confirmar
                        </Button> : null,
                ]}
            >
                <Grid container direction="row">
                    <Grid item xs={12} >
                        <Alert
                            message="Información Adicional"
                            description={'Se recomienda el uso de siglas o nombre de referencia cortos.'}
                            type="info"
                            showIcon
                        />
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: '10px' }}>
                        <TextInput
                            disabled={siteId !== 'HUB'}
                            value={props.nameClient}
                            setValue={props.setNameClient}
                            text='Nombre de la compañía:'
                            color='darker'
                            size='label'
                            weight='medium'
                            mode='input'
                            placeholder='Nombre'
                        />
                    </Grid>
                </Grid>
            </Modal>
        </div>
    );
}